@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}

<h1>
  @switch(editing) {
    @case(true) {
      <span>Edit Cert pair for ven {{cert_id}}</span>
    }
    @case(false) {
      <span>Register a new Cert pair</span>
    }
  }
</h1>
<p class="lead">
  The secondary certs are optional. When updating an existing cert, you do not need to re-upload already uploaded files again if they are not changing. If you upload one certificate (public or private), you must upload its corresponding pair.
</p>
@if(isLoading) {
  <app-loader
    message="Loading...">
  </app-loader>
} @else {
  <form name="certForm" class="form-horizontal" [formGroup]="certForm">
    <div class="form-group">
      <label for="venId"> Ven name: </label>
      <select id="venId" class="form-control" name="ven_id" type="select" formControlName="vens" required>
        @for(ven of vens; track ven){
          <option [ngValue]="ven.id" [selected]="editVens === ven?.id">{{ven?.venName}}</option>
        }
      </select>
      @if(certForm.get('vens')?.invalid && (certForm.get('vens')?.dirty || certForm.get('vens')?.touched)) {
        <div class="text-danger">
          <div *ngIf="certForm.get('vens')?.errors?.['required']">VEN is required.</div>
        </div>
      }
    </div>
    <div class="form-group">
      <label for="public"> Public cert: </label>
      <input id="public" class="form-control" name="public_cert" type="file" #filePicker (change)="onImagePicked($event, 'publicCert')" required>
      @if(certForm.get('publicCert')?.invalid && (certForm.get('publicCert')?.dirty || certForm.get('publicCert')?.touched)) {
        <div class="text-danger">
          <div *ngIf="certForm.get('publicCert')?.errors?.['required']">Public certificate is required.</div>
        </div>
      }
      @if(cert.private_key && !cert.public_cert && editing) {
        <div class="text-danger">
          Both public certificate and private key must be provided together.
        </div>
      }
    </div>
    <div class="form-group">
      <label for="private"> Private key: </label>
      <input id="private" class="form-control" name="private_key" type="file" #filePicker (change)="onImagePicked($event, 'privateKey')" required>
      @if(certForm.get('privateKey')?.invalid && (certForm.get('privateKey')?.dirty || certForm.get('privateKey')?.touched)) {
        <div class="text-danger">
          <div *ngIf="certForm.get('privateKey')?.errors?.['required']">Private key is required.</div>
        </div>
      }
      @if(cert.public_cert && !cert.private_key && editing) {
        <div class="text-danger">
          Both public certificate and private key must be provided together.
        </div>
      }
    </div>

    <div class="form-group">
      <button class="btn btn-default" type="button" (click)="toggleSecondaryCerts()" data-toggle="collapse" data-target="#secondaryCerts" aria-expanded="false">
        <span [ngClass]="secondaryCertToggle ? 'glyphicon glyphicon-collapse-up' : 'glyphicon glyphicon-collapse-down'" aria-hidden="true"></span> Optional Secondary Certs
      </button>
      <div id="secondaryCerts" [ngClass]="secondaryCertToggle ? '' : 'collapse'">
        <p>Optional secondary certs to use when connecting to secondary VTN. Both files must be provided if you want to add secondary certificates.</p>
        <label for="secondary_public"> Secondary public cert: </label>
        <input id="secondary_public" class="form-control" name="secondary_public_cert" type="file" #filePicker (change)="onImagePicked($event, 'secondaryPublicCert')">
        @if(cert.secondary_private_key && !cert.secondary_public_cert) {
          <div class="text-danger">
            Secondary public certificate is required when adding a secondary private key.
          </div>
        }

        <label for="secondary_private"> Secondary private key: </label>
        <input id="secondary_private" class="form-control" name="secondary_private_key" type="file" #filePicker (change)="onImagePicked($event, 'secondaryPrivateKey')">
        @if(cert.secondary_public_cert && !cert.secondary_private_key) {
          <div class="text-danger">
            Secondary private key is required when adding a secondary public certificate.
          </div>
        }
      </div>
    </div>

    <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="certForm.invalid && !editing">Save</button>
    <a class="btn" (click)="backPage('/certs', route)">Cancel</a>
  </form>
}
